import React from "react";
import { makeStyles } from "@material-ui/core";

import styles from "./styles";
const useStyles = makeStyles(styles);

function ServiceItem({ service, onSelect, ...rest }) {
  const classes = useStyles();
  const handleSelect = () => onSelect(service);

  return (
    <li {...rest} className={classes.container} onClick={handleSelect}>
      {service.nmServico}
    </li>
  );
}

export default ServiceItem;
